<template>
  <footer class="opixFooter footer hidden-print">
    <div class="footerCopyright">
      <div class="jpxLogoArea">
        <picture class="paddingR4">
          <img src="/img/tokyo_growth_logo.png" alt="東証ロゴ" width="67" height="86" />
        </picture>
        <div>
          <p>株式会社リンクバルは、東京証券取引所グロース市場に上場しております。</p>
          <p>（証券コード：6046）</p>
        </div>
      </div>
      <ul v-if="links" class="footerLinks">
        <li v-for="(row, i) in linkList" :key="i" class="footerLinks-item">
          <div class="footerLinks-item-title">{{ row.title }}</div>
          <ul class="footerLinks-item-list linkList">
            <li v-for="(linkItem, i) in row.links" :key="i" :class="{ fullWidth: linkItem.fullWidth }" class="linkList-item">
              <custom-nuxt-link v-if="linkItem.link" :to="linkItem.link" class="linkList-item-link">{{ linkItem.label }}</custom-nuxt-link>
              <a v-else-if="linkItem.externalLink" :href="linkItem.externalLink" class="linkList-item-link" rel="noreferrer" target="_blank">{{
                linkItem.label
              }}</a>
            </li>
          </ul>
        </li>
        <li>
          <add-line-friend :class="{ marginT3: $store.isSP }" class="commonStyle" />
          <couplink-mobile-apps v-if="!$store.native_app" class="opixCLMobileApps commonStyle marginT5" />
        </li>
      </ul>
      <div :class="{ forSpecialPass: isOnlineSpecialPassEvent }" class="footerCopyright-description">
        Copyright © LINKBAL Inc. All Rights Reserved.
      </div>
    </div>
  </footer>
</template>

<script>
import PageDetector from '@/utils/PageDetector'
import { CACHE_COMMON_FOOTER } from '@/utils/constants/serverCaching'

const LINKS = [
  {
    title: 'machicon JAPANについて',
    links: [
      { label: '会社概要', externalLink: 'https://linkbal.co.jp/' },
      { label: 'スタッフ募集', externalLink: 'https://linkbal.co.jp/recruit/' },
      { label: 'リンク方法', link: '/link/' },
      { label: 'サイトマップ', link: '/site-map/' },
      { label: '取材・プレスについてのお問い合わせ', externalLink: 'https://linkbal.co.jp/contact/press/', fullWidth: true },
      { label: 'イベント掲載のお問い合わせ', link: '/advertisement/' }
    ]
  },
  {
    title: '利用規約とプライバシー',
    links: [
      { label: '利用規約', link: '/terms_of_service/', fullWidth: true },
      { label: 'プライバシーポリシー', externalLink: 'https://linkbal.co.jp/privacy/', fullWidth: true },
      { label: '特定商取引法に関する表示', link: '/tokushou/' }
    ]
  },
  {
    title: 'グループサービス',
    links: [
      { label: 'CoupLink', externalLink: 'https://couplink.jp/?utm_source=mj&utm_medium=referral&utm_campaign=footer_group_service' },
      { label: 'Pairy', externalLink: 'https://pairy.com/?utm_source=mj&utm_medium=referral&utm_campaign=footer_group_service' },
      { label: 'KOIGAKU', externalLink: 'https://koigaku.machicon.jp/?utm_source=mj&utm_medium=referral&utm_campaign=footer_group_service' },
      { label: '1on1 for Singles', externalLink: 'https://1on1.singles/?utm_source=mj&utm_medium=referral&utm_campaign=footer_group_service' },
      { label: 'MiDATA', externalLink: 'https://midata.co.jp/?utm_source=mj&utm_medium=referral&utm_campaign=footer_group_service' }
    ]
  }
]
export default {
  name: CACHE_COMMON_FOOTER.name,
  serverCacheKey() {
    return Math.floor(Date.now() / CACHE_COMMON_FOOTER.time)
  },
  props: {
    links: { type: Boolean, required: false, default: true },
    totop: { type: Boolean, required: false, default: true },
    logo: { type: Boolean, required: false, default: true }
  },
  computed: {
    linkList() {
      return LINKS
    },
    pageDetector() {
      return new PageDetector(this.$route)
    },
    isOnlineSpecialPassEvent() {
      return (
        this.pageDetector.isEventDetailPage &&
        [import.meta.env.ONLINE_FITNESS_PASS_EVENT_CODE, import.meta.env.ONLINE_CAFETALK_YOGA_PASS_EVENT_CODE].includes(this.$route.params.code)
      )
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  text-align: left;
}

.footerLinks {
  display: flex;
  @include contentInner;
  @include sp {
    display: block;
  }
  &-item {
    @include pc {
      width: 33.33333%;
    }
    &:not(:first-child) {
      @include sp {
        margin-top: 2em;
      }
    }
    &-title {
      font-size: 1.8rem;
      font-weight: bold;
      color: $white;
      margin-bottom: 1rem;
    }
    .linkList {
      font-size: 1.2rem;
      &-item {
        margin-bottom: 1.6rem;
        @include sp {
          display: inline-block;
          width: 50%;
        }
        &.fullWidth {
          @include sp {
            width: 100%;
          }
        }
        &-link {
          color: $white;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

.footerCopyright {
  background: $gray-55;
  font-size: 1rem;
  color: $gray-f1;
  padding: 3rem 3rem 4rem;
  @include sp {
    padding: 1.6rem 1.6rem 3rem;
  }
  &-description {
    margin-top: 3em;
    @include contentInner;
    &.forSpecialPass {
      margin-bottom: 5rem;
    }
  }
  .jpxLogoArea {
    display: flex;
    margin-bottom: 2rem;
    align-items: center;
    @include contentInner;
    picture img {
      min-width: 67px;
    }
    p {
      font-size: 12px;
      font-weight: bold;
    }
  }
}
</style>
